/* @flow */

import { useEffect, useState } from "react";
import { throttle } from "diskho";
import { useBrowser } from "@awardit/react-use-browser";

const useBrowserDimensions = (): { width: number, height: number } => {
  const isBrowser = useBrowser();
  const [width, setWidth] = useState(isBrowser ? window.innerWidth : 0);
  const [height, setHeight] = useState(isBrowser ? window.innerHeight : 0);

  useEffect(() => {
    if (isBrowser) {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);

      const handleResize = throttle(() => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
      }, 1000);

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [isBrowser]);

  return {
    width,
    height,
  };
};

export default useBrowserDimensions;
